import * as busyCounter from '../../../sharedmodules/action-creators/busy-counter';

import { addNotification } from '../repositories/addNotification';
import { createNotificationRequestPayload } from '../services/create-notification-request-payload';
import { createSuccessMessage } from '../../../sharedmodules/action-creators/alert-messages';
import { handleError } from '../../../sharedmodules/services/error-handlers';
import { readNotificationData } from './read-notification';
import { translate } from '../../../sharedmodules/services/translation-service';
import { updateModalVisibility } from '../../../sharedmodules/action-creators/modal';

export const addNotificationData = (getAccessToken, notification, isVisible) => {

    const notificationRequest = createNotificationRequestPayload(notification);

    return async (dispatch) => {

        dispatch(busyCounter.increaseBusyCounter());
        try {

            const notificationData = await addNotification(getAccessToken, notificationRequest);
            if (notificationData.status === 201) {

                dispatch(createSuccessMessage(translate('NOTIFICATION_ADDED_SUCCESSFULLY')));
                dispatch(readNotificationData(getAccessToken));

            }

        } catch (error) {

            handleError(error);

        } finally {

            setTimeout(() => {

                dispatch(updateModalVisibility(isVisible));
                dispatch(busyCounter.decreaseBusyCounter());

            }, 200);

        }

    };

};
